export const SAMPLER = 'SAMPLER';
export const MIDI = 'MIDI';
export const AUDIO = 'AUDIO';
export const Z4 = 'Z4';
export const INSTRUMENT = 'INSTRUMENT';
export const INSTRUMENT_RACK = 'INSTRUMENT_RACK';
export const MULTI_FREEZE = 'MULTI_FREEZE';
